"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactEmotion = require("react-emotion");

var root = function root(fillColor, type) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:inline-block;width:20px;height:20px;border-radius:50%;background-color:", fillColor, ";line-height:20px;margin-right:15px;", !type && "\n    height: 0;\n    width: 0;\n  ")
  );
};

var icon = function icon(iconColor) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("fill:", iconColor, ";")
  );
};

var _default = {
  root: root,
  icon: icon
};
exports.default = _default;